/**
 * Base Service
 * @author PhuongDP
 */
import {environment} from '../../../environments/environment.dev';
import {HttpHeaders} from '@angular/common/http';

export class BaseService {

  httpOptions = {
    headers: new HttpHeaders({
      'Accept': '*/*',
      'Content-Type':  'application/json',
      'Access-Control-Allow-Origin': '*'
    })
  };

  httpOptionsFormData = {
    headers: new HttpHeaders({
      'Accept': 'application/json'
    })
  };

  protected apiUrl: string = environment.apiUrl;

  constructor() {
  }
}
